var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurfboardAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3978 18.1087C21.0602 19.5025 20.5816 20.8292 19.9643 22H14.4868C13.8897 20.7401 13.4176 19.3136 13.0837 17.825L17.2631 15.3826L21.3978 18.1087Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7171 16.5225C22.1332 13.9532 22.0923 11.2746 21.5809 9C20.9273 6.0934 18.2204 2 17.287 2C16.3536 2 13.4471 6.04295 12.8411 9C12.3948 11.1776 12.3966 13.7545 12.7872 16.261L17.3109 13.6174L21.7171 16.5225Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7573 8.80717C10.9785 9.18119 11.1876 9.57377 11.3835 9.98197C10.7573 13.3257 11.0438 16.5 13 22H10.7743L7.93677 12.8716C7.81412 12.4771 7.40158 12.2583 7.01547 12.3833C6.62934 12.5093 6.41586 12.9312 6.53854 13.3257L9.23489 22H6.24423C3.98155 19.0309 2.33551 15.0587 2.02878 11.6431C1.75802 8.62846 3.46307 3.83158 4.39527 3.52885C5.32743 3.22612 9.24361 6.24955 10.7573 8.80717Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurfboardAlt1);
export default __webpack_public_path__ + "static/media/surfboard-alt-1.a832705c1f2a4507b3f3ec356c011517.svg";
export { ForwardRef as ReactComponent };